var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"dark":"","dense":"","grow":"","centered":""},model:{value:(_vm.selectedNavLinkAux),callback:function ($$v) {_vm.selectedNavLinkAux=$$v},expression:"selectedNavLinkAux"}},_vm._l((_vm.linkList),function(name,index){return _c('v-tab',{key:name,class:[
      _vm.selectedNavLinkAux === index ? 'active' : '',
      _vm.isLight ? 'lightTab' : '',
      _vm.isDark ? 'darkTab' : ''
    ],attrs:{"value":index},on:{"click":function($event){return _vm.onClientSelect(index)}}},[_vm._v(_vm._s(name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }